import { render, staticRenderFns } from "./H5Listofawards.vue?vue&type=template&id=6caf3524&"
import script from "./H5Listofawards.vue?vue&type=script&lang=js&"
export * from "./H5Listofawards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports